import styled, { css } from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CrumbsWrap = styled.div``;

export const Crumbs = styled.div`
    display: flex;
    margin-top: 25px;
`;

export const CrumbElem = styled.a<{ isDisabled: boolean }>`
    ${FONTS.MediumS};
    color: grey;
    ${(p) => p.isDisabled
        ? css`
            cursor: default;
            pointer-events: none;
            text-decoration: none;
        `
        : css`
            text-decoration: underline;
        `
    }
`;

export const CrumbsSeparate = styled.span`
    color: grey;
    padding: 0 5px;
    text-decoration: none;
`;
